import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import AppPaginatedTable from "components/ui/AppPaginatedTable";

const CustomerTable = ({ customers = { data: [] }, searchTerm = "" }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const filteredCustomers = useMemo(() => {
    const raw = customers?.data || [];
    const term = searchTerm?.trim().toLowerCase();
    if (!term) return raw;

    return raw.filter((row) => {
      const name = String(row?.name ?? "").toLowerCase();
      const phone = String(row?.customerPhone ?? "").toLowerCase();
      const cod = String(row?.codEarning ?? "").toLowerCase();
      const online = String(row?.onlineEarning ?? "").toLowerCase();
      return (
        name.includes(term) ||
        phone.includes(term) ||
        cod.includes(term) ||
        online.includes(term)
      );
    });
  }, [customers?.data, searchTerm]);

  useEffect(() => {
    setPage(1);
  }, [searchTerm]);

  const columns = [
    {
      title: t("Customer Name"),
      dataIndex: "name",
      align: "initial",
      key: "customerName",
      render: (val) => (
        <div>
          <span>{val || t("N/A")}</span>
        </div>
      ),
    },
    {
      title: t("Phone Number"),
      dataIndex: "customerPhone",
      align: "initial",
      key: "customerPhone",
      render: (val) => (
        <div>
          <span dir="ltr">{val}</span>
        </div>
      ),
    },
    {
      title: t("CASH Spending"),
      dataIndex: "codEarning",
      align: "initial",
      key: "codEarning",
    },
    {
      title: t("ONLINE Spending"),
      dataIndex: "onlineEarning",
      align: "initial",
      key: "onlineEarning",
    },
  ];

  return (
    <div className="w-full">
      <AppPaginatedTable
        columns={columns}
        data={filteredCustomers}
        clientSidePagination={true}
        page={page}
        pageSize={pageSize}
        total={filteredCustomers.length}
        rowIndexKey="customerId"
        onPageChange={(nextPage, nextPageSize) => {
          setPage(nextPage);
          setPageSize(nextPageSize);
        }}
      />
    </div>
  );
};

export default CustomerTable;
